import { Fragment, useEffect } from "react"

import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router"

import { getJourneyState } from "../../../../Utils/onboarding/getJourneyState"
import {
  CHOICE_FLOWS,
  hasOnboardingProgress,
  resolveProductChoice
} from "../../../../Utils/onboarding/productChoice"
import { getSkippedStepKeys } from "../../../../Utils/onboarding/stepSequence"
import { FEATURES_STEP_PATH } from "../../../../Utils/utils"
import { BA_STEPS } from "../../../GettingStartedPage/utils/businessSteps"
import { getMaxCreateSteps } from "../../../User/redux/user.thunks"
import { createSteps } from "../../utils/constants/createSteps"
import { getAlertSubSteps } from "../../utils/helpers/getAlertSubSteps"
import { getRailState } from "../../utils/helpers/getRailState"
import { getStepState } from "../../utils/helpers/getStepState"
import OnboardingStep from "../OnboardingStep"
import OnboardingSubStep from "../OnboardingSubStep"

import "../../styles.less"

const BusinessSideBar = ({ showSubSteps }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const userInfo = useSelector((state) => state.auth.userInfo)
  const userState = useSelector((state) => state.user)
  const enrollments = useSelector((state) => state.user.enrollments)
  const journey = getJourneyState({
    userInfo,
    userState,
    pathname
  })

  useEffect(() => {
    dispatch(getMaxCreateSteps())
  }, [])

  const flow = CHOICE_FLOWS.BUSINESS
  const choice = resolveProductChoice({
    flow,
    hasProgress: hasOnboardingProgress({ flow, nextCreateAccountStep: journey.currentStep })
  })
  // The journey lists the backend steps this business walks (billing steps already dropped
  // when the account has them); the choice drops the Prevent-only ones, and the features row
  // is always first.
  const journeyIds = journey.steps.map((s) => s.step)
  const steps = createSteps(BA_STEPS, { exclude: getSkippedStepKeys(choice) }).filter(
    (s) => s.stepId == null || journeyIds.includes(s.stepId)
  )
  const currentKey = pathname.split("/")[2]
  const isAlertPage = pathname.includes("/alerts")

  const activeEnrollments = enrollments?.filter((enrollment) => enrollment.is_active)
  const isActiveRDR = activeEnrollments.some((enrollment) => enrollment.name === "RDR")

  return (
    <div className="ob-steps">
      {steps.map((s, index) => {
        const { isProcess, isSub } = getStepState(
          s.stepId,
          journey.currentStep,
          BA_STEPS,
          showSubSteps,
          isAlertPage
        )
        const { done, active, block } = getRailState({
          steps,
          index,
          currentKey,
          progressStepId: journey.currentStep,
          featuresDone: choice !== null
        })

        return (
          <Fragment key={s.key}>
            <OnboardingStep
              label={s.label}
              done={done}
              active={active}
              process={isProcess}
              sub={isSub}
              onClick={() => {
                if (block) return
                navigate(
                  s.stepId == null ? FEATURES_STEP_PATH.business : `/create-account/${s.key}`
                )
              }}
            />

            {isSub && (
              <div className="ob-subSteps">
                {getAlertSubSteps(showSubSteps, s.subSteps)
                  .filter((ss) => ss.key !== "bin" || isActiveRDR)
                  .map((ss) => (
                    <OnboardingSubStep key={ss.key} {...ss} />
                  ))}
              </div>
            )}
          </Fragment>
        )
      })}
    </div>
  )
}

export default BusinessSideBar
